import * as React from 'react';
import { cn } from '@/lib/utils';
import { IconVerified } from '@/components/custom/icon';

const GeneratedContentWrapper = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-generated-content-wrapper', 'inline-flex max-w-full items-center gap-1', className)}
    {...props}
  />
));
GeneratedContentWrapper.displayName = 'GeneratedContentWrapper';

const GeneratedContentText = React.forwardRef(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn('c-generated-content-text', 'shrink truncate', className)}
    {...props}
  />
));
GeneratedContentText.displayName = 'GeneratedContentText';

const GeneratedContent = React.forwardRef(({ className, authorName, verified, ...props }, ref) => (
  <GeneratedContentWrapper
    ref={ref}
    className={cn('c-generated-content', className)}
    {...props}
  >
    {authorName && <GeneratedContentText title={authorName}>{authorName}</GeneratedContentText>}
    {verified && <IconVerified />}
  </GeneratedContentWrapper>
));
GeneratedContent.displayName = 'GeneratedContent';

export { GeneratedContentWrapper, GeneratedContentText, GeneratedContent };
